/**
 * The FIGlet fonts Insert FIGlet text offers, from github.com/xero/figlet-fonts. The font
 * files in figlet-fonts/ are kept whole, with their authors' notes, and load only once the
 * dialog opens.
 */
export const FIGLET_FONTS = [
  { id: "3d", label: "3D" },
  { id: "ansi-regular", label: "ANSI Regular" },
  { id: "dos-rebel", label: "DOS Rebel" },
  { id: "slant", label: "Slant" },
  { id: "miniwi", label: "miniwi" },
  { id: "univers", label: "Univers" },
] as const;
export type FigletFontId = (typeof FIGLET_FONTS)[number]["id"];

/** What the previews say until something is typed. */
export const FIGLET_SAMPLE = "TurboNotes";

/** FIGlet text as a fenced code block, so Markdown keeps its spacing and leaves its _ * \ alone. */
export function figletBlock(art: string): string {
  const longest = Math.max(2, ...[...art.matchAll(/`+/g)].map((run) => run[0].length));
  const fence = "`".repeat(longest + 1);
  return `${fence}\n${art}\n${fence}`;
}
